export default __webpack_public_path__ + "/dist/images/cibecco-logo-new.1daece30e7ccbd4ea2632d71d77116be.svg";